import { Stack, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { Assessment } from 'types/analysis-result.types';

interface Props {
  assessment: Assessment;
}

const PersonalityType: React.FC<Props> = ({ assessment }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const motiveIllustrationGenerator = () => {
    const baseUrl = '/dashboard/images/illustrations/';

    const motive = assessment?.name || '';

    return `${baseUrl}${_.replace(_.toLower(motive), ' ', '')}.png`;
  };

  return (
    <Stack gap={1}>
      <Stack className={classes.illustrationCard} justifyContent={'center'} alignItems={'center'}>
        <img className={classes.illustration} src={motiveIllustrationGenerator()} alt="motive illustration" />
      </Stack>
      <Stack className={classes.assessment}>
        <div>
          <Typography className={classes.title}>{t('characteristics')}</Typography>
          <ul className={classes.list}>
            {assessment?.instructions?.descriptions?.shortdescription?.split(',').map((item, index) => (
              <Typography key={index} className={classes.text} component={'li'}>
                {item.trim()}
              </Typography>
            ))}
            {assessment?.instructions?.descriptions?.listdescription?.map((item, index) => (
              <Typography key={index} className={classes.text} component={'li'}>
                {item}
              </Typography>
            ))}
          </ul>
        </div>
        <div>
          <Typography className={classes.title}>{t('priorities')}</Typography>
          <ul className={classes.list}>
            {assessment.instructions?.descriptions?.importantdescription?.map((item, index) => (
              <Typography key={index} className={classes.text} component={'li'}>
                {item}
              </Typography>
            ))}
          </ul>
        </div>
        <div>
          <Typography className={classes.title}>{t('does')}</Typography>
          <ul className={classes.list}>
            {assessment.instructions?.descriptions?.dos?.map((item, index) => (
              <Typography key={index} className={classes.text} component={'li'}>
                {item[0]}
                <ul className={classes.subList}>
                  <Typography key={index} className={classes.text} component={'li'}>
                    {item[1]}
                  </Typography>
                </ul>
              </Typography>
            ))}
          </ul>
        </div>
        <div>
          <Typography className={classes.title}>{t('donts')}</Typography>
          <ul className={classes.list}>
            {assessment.instructions?.descriptions?.donts?.map((item, index) => (
              <Typography key={index} className={classes.text} component={'li'}>
                {item[0]}
                <ul className={classes.subList}>
                  <Typography key={index} className={classes.text} component={'li'}>
                    {item[1]}
                  </Typography>
                </ul>
              </Typography>
            ))}
          </ul>
        </div>
      </Stack>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  assessment: {
    padding: '8px 0 0 4px',
  },
  list: {
    paddingInlineStart: '16px',
    marginBlockStart: '16px',
    marginBlockEnd: '16px',
  },
  subList: {
    paddingInlineStart: '16px',
    marginBlockStart: '4px',
    marginBlockEnd: '4px',
  },
  title: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    textDecoration: 'underline',
  },
  text: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.greys.medium,
    padding: '0 4px',
    whiteSpace: 'pre-wrap',
  },
  illustrationCard: {
    padding: '8px 16px 16px 16px',
    borderBottom: `2px solid ${theme.palette.backgrounds.main}`,
  },
  illustration: {
    width: 'auto',
    maxWidth: 'fit-content',
    maxHeight: '125px',
  },
}));

export default PersonalityType;
